import algoliasearch from 'algoliasearch/lite';
import { buildPublishedFiltersString } from '../AlgoliaSearchPage.filters';
import { MAX_MAP_HITS } from './mapListings';

let client;
const getClient = () => {
  if (!client) {
    client = algoliasearch(
      process.env.REACT_APP_ALGOLIA_APP_ID,
      process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY
    );
  }
  return client;
};

const getIndexName = kind =>
  kind === 'deal'
    ? process.env.REACT_APP_ALGOLIA_DEALS_INDEX
    : process.env.REACT_APP_ALGOLIA_SERVICE_INDEX;

/**
 * Services or deals inside a map area. A listing sits at its merchant's
 * location (`_geoloc`).
 *
 * - `bounds` is an Algolia bounding box: [[north, east, south, west]].
 * - `filters` are the page's extra filter fragments (price cap, deal category);
 *   `state:published` is always added.
 * - `around` ({lat, lng}) only adds nearest-first order. Never add
 *   `aroundRadius`: it makes Algolia ignore the bounding box.
 *
 * Resolves `{hits, nbHits}`; rejects if the request fails.
 */
export const fetchListingsInBounds = async ({
  kind,
  bounds,
  query = '',
  filters = [],
  facetFilters,
  hitsPerPage = MAX_MAP_HITS,
  around,
}) => {
  const hasFacets = Array.isArray(facetFilters) ? facetFilters.length > 0 : !!facetFilters;
  const params = {
    hitsPerPage,
    filters: buildPublishedFiltersString(filters),
    insideBoundingBox: bounds,
    ...(hasFacets ? { facetFilters } : {}),
    ...(around && around.lat && around.lng ? { aroundLatLng: `${around.lat},${around.lng}` } : {}),
  };
  const { results } = await getClient().search([
    { indexName: getIndexName(kind), query: (query || '').trim(), params },
  ]);
  const result = (results && results[0]) || {};
  return { hits: result.hits || [], nbHits: result.nbHits || 0 };
};
